import { useTranslation } from 'react-i18next';

import { LoadingView } from '../../../../components/LoadingView';
import { PreferencesInnerModal } from '../PreferencesInnerModal';

import { MetricsGroups } from './MetricsGroups';
import { StyledMetricsContainer } from './styles';
import { useMetricsPreferences } from './useMetricsPreferences';

type MetricsProps = {
  isOpen: boolean;
  onClose: () => void;
  onCloseInnerModal: () => void;
};

export const Metrics = ({ isOpen, onClose, onCloseInnerModal }: MetricsProps) => {
  const { t } = useTranslation();

  const {
    selectedMetrics,
    handleSave,
    isLoading,
    isMutationLoading,
    handleMetricClick,
    groupedMetrics,
    isSaveDisabled,
    isNoChangeInValues,
  } = useMetricsPreferences(onClose);

  return (
    <PreferencesInnerModal
      isOpen={isOpen}
      onClose={onClose}
      onSave={handleSave}
      onReturn={onCloseInnerModal}
      title={t('insights.preferences.metrics.title')}
      subtitle={t('insights.preferences.metrics.subtitle')}
      tooltipContent={
        isNoChangeInValues
          ? t('insights.preferences.metrics.no_change.tooltip')
          : t('insights.preferences.metrics.disabled.tooltip')
      }
      isSaveDisabled={isSaveDisabled}
      isLoading={isMutationLoading}
    >
      <>
        {isLoading ? (
          <LoadingView />
        ) : (
          <StyledMetricsContainer>
            <MetricsGroups
              groupedMetrics={groupedMetrics}
              selectedMetrics={selectedMetrics}
              onMetricClick={handleMetricClick}
            />
          </StyledMetricsContainer>
        )}
      </>
    </PreferencesInnerModal>
  );
};
